import {
  fetchAPI,
  TASKS_SERVICE_URL,
} from "@coworker/app/src/hooks/API/tasks.service.helper";
import { useQuery } from "@tanstack/react-query";
import { INTERVAL } from "@coworker/app/src/constants/clientTime";
import { ImageDetails } from "../types/ImageDetailsType";
import { FetchApiResponse } from "@coworker/apprestructured/src/shared/types/fetchApiResponseType";

async function fetchTaskNoteImagesDetails(taskId: string) {
  const url = `${TASKS_SERVICE_URL}/v1/task/${taskId}/notes/images`;
  const { result } = (await fetchAPI("GET", url)) as FetchApiResponse;
  return result as ImageDetails[];
}

export function useTaskNotesImagesDetails(taskId: string) {
  return useQuery<ImageDetails[]>({
    queryKey: ["task", "notes", "images", taskId],
    queryFn: async () => await fetchTaskNoteImagesDetails(taskId),
    staleTime: INTERVAL.HOUR,
    refetchOnWindowFocus: false,
    enabled: !!taskId,
  });
}
